import React from "react";
import { withStyles } from "@material-ui/core/styles";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelActions from "@material-ui/core/ExpansionPanelActions";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import TagsManager from "../../../tags-manager";

const styles = theme => ({
  root: {
    width: "100%"
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular
  }
});

const LayerItem = ({ id, name, metadata, query, classes, layer, _id }) => {
  return (
    <ExpansionPanel>
      <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
        <Typography className={classes.heading}>{name}</Typography>
      </ExpansionPanelSummary>
      <ExpansionPanelDetails>
        <Typography>Metadata: {JSON.stringify(metadata, null, 2)}</Typography>
      </ExpansionPanelDetails>
      <ExpansionPanelActions>
        <TagsManager contextType="RESOURCE" contextId={_id} isResource={true} />
      </ExpansionPanelActions>
    </ExpansionPanel>
  );
};

export default withStyles(styles)(LayerItem);



// WEBPACK FOOTER //
// ./src/components/admin/carto/resources/item.js